/* Catálogo da empresa escolhida: empresas liberadas, obras e opções dos gráficos (GET /catalogo). */

import { api } from './api';
import { CFG } from './config';
import { cat, state } from './estado';
import type { Catalogo, Categoria } from '../tipos/api';

type AoCarregar = (c: Catalogo) => void;
const ouvintes: AoCarregar[] = [];

/** Avisa quando um catálogo novo é carregado (ex.: atualizar o nome da empresa no topo). */
export const aoCarregarCatalogo = (fn: AoCarregar) => ouvintes.push(fn);

export async function carregaCatalogo(): Promise<Catalogo> {
  const key = `${CFG.modo}|${CFG.base}|${CFG.apiKey}|${CFG.cnpj}`;
  if (state.cat && state.catKey === key) return state.cat;
  if (state.catPromise && state.catKey === key) return state.catPromise;
  state.catKey = key;
  state.cat = null;
  state.catErro = null;
  state.catPromise = api<Catalogo>('GET', '/catalogo')
    .then((c) => {
      state.cat = c;
      ouvintes.forEach((fn) => fn(c));
      return c;
    })
    .catch((e) => {
      state.catErro = e;
      throw e;
    })
    .finally(() => {
      state.catPromise = null;
    });
  return state.catPromise;
}

export function esquecerCatalogo(): void {
  state.cat = null;
  state.catKey = null;
}

export const catBySlug = (slug: string | null): Categoria =>
  cat().categorias.find((c) => c.slug === slug) || cat().categorias[0];

export const obraNome = (id: unknown): string => state.cat?.obras.find((o) => o.id === id)?.nome || '';
